import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function ThankYouPartnerships() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100"
        >
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-secondary-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>
          
          <h1 className="text-3xl font-display font-bold text-gray-900 mb-4">
            Thank You for Your Partnership Enquiry!
          </h1>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            We've received your request to partner with us. Our partnerships team will review your enquiry and get back to you shortly.
          </p>
          
          <div className="space-y-4">
            <Link 
              to="/" 
              className="btn-primary w-full inline-block text-center py-3"
            >
              Back to Home
            </Link>
          </div>
        </motion.div>
        
        <p className="mt-8 text-sm text-gray-500">
          Want to learn more about our solutions? <Link to="/about" className="text-primary-600 font-medium hover:text-primary-700">Explore our story</Link>
        </p>
      </div>
    </div>
  );
}

export default ThankYouPartnerships;
